import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeader } from "@/components/page-header";
import { usePageTitle } from "@/hooks/use-page-title";

export default function Analytics() {
  usePageTitle("Analytics");
  return (
    <div className="flex-1 px-6 pb-6 pt-4">
      {/* Gate E3.7.2: Global page header with breadcrumb + title */}
      <PageHeader
        breadcrumb={[{ label: "Reporting" }, { label: "Analytics" }]}
        title="Analytics"
      />

      <Card>
        <CardHeader>
          <CardTitle>Analytics Dashboard</CardTitle>
          <CardDescription>
            Trends, insights, and historical data analysis across all locations
          </CardDescription>
        </CardHeader>
        <CardContent className="p-8">
          <div className="text-center text-muted-foreground">
            <p className="mb-2">Analytics dashboard coming soon</p>
            <p className="text-sm">
              This page will provide trend analysis, population insights, length-of-stay metrics, and behavioral patterns over time.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
